<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="headline">倉庫別予約一覧</div>
        </div>
      </v-card-title>
      <v-card-actions style="display: flex; width: 100%">
        <div>
          <v-btn
            @click="search()"
            v-permit.RESERVE_WAREHOUSE_SEARCH
            class="btn-search"
            >{{ $t("app.buttons.search") }}</v-btn
          >
          <v-btn
            v-permit.RESERVE_WAREHOUSE_JUMP
            :disabled="selected.length === 0 || !canMove"
            @click="needNotReserve()"
            >納入指示へ
          </v-btn>
          <v-btn v-permit.WAREHOUSE_SETTING @click="toWarehouseSetting()"
            >倉庫表示設定
          </v-btn>
          <v-btn
            v-permit.EXCEPTION_APPLY
            :disabled="selected.length === 0 || !canDoExceptionApply"
            @click="excludedInstruction()"
            >例外納入指示
          </v-btn>
          <v-btn
            v-permit.BATCH_RESERVE
            :disabled="selected.length === 0 || !sameBL || hasSent"
            @click="randomInstruction()"
            >おまかせ納入指示
          </v-btn>
          <v-btn v-permit.ADJUST_CONTAINER @click="adjustContainers()"
            >コンテナ調整
          </v-btn>
          <v-btn
            v-permit.REPLACE_BOOKING_SA
            :disabled="selected.length !== 1"
            @click="replace()"
          >
            仮予約置換
          </v-btn>
          <v-btn
            v-permit.CANCEL_BOOKING_SA
            :disabled="!canCancelBookingDo"
            @click="cancelBookingSa()"
          >
            仮予約取消
          </v-btn>
          <v-btn
            v-permit.EDIT_FREE_TIME
            :disabled="selected.length === 0 || !canChangeFreeDays"
            @click="openChangeFreeDaysDialog()"
          >
            フリータイム変更
          </v-btn>
          <v-btn v-permit.WAREHOUSE_DAILY_REPORT to="/B2300/reserve-forecast"
            >コンテナ受入計画</v-btn
          >
          <v-btn v-permit.WAREHOUSE_CONTAINER_REPORT @click="packagesDownload"
            >納入日別倉庫別コンテナ明細の出力</v-btn
          >
          <v-btn :disabled="!canEditLogisticsSku" @click="editLogisticsSku()"
            >物流社内品番明細</v-btn
          >
          <v-btn @click="clearQuery()">検索条件クリア</v-btn>
        </div>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="陸揚港"
                url="ports/kv"
                v-model="query.dischargePortCode"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="コンテナNo"
                v-model="query.containerNo"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="B/L No" v-model="query.blNo" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input
                    :max="query.etaTo"
                    label="ETA"
                    v-model="query.etaFrom"
                  ></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input
                    :min="query.etaFrom"
                    v-model="query.etaTo"
                  ></date-input>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="最終納入場所"
                url="warehouses/reservable-kv"
                v-model="query.finallyWarehouseId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-select
                :items="status"
                :multiple="true"
                clearable
                item-text="value"
                item-value="value"
                label="ステータス"
                v-model="multiStatus"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="D/O No" v-model="query.doNo" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="納入指示者"
                url="employees/kv?types=SHARP,SJL"
                v-model="query.operateDirectorId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                :url="`/divisions/kv?type=BU`"
                v-model="query.buId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="BU"
                :url="`/divisions/kv?type=BUSINESS_UNIT`"
                v-model="query.businessUnitId"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <fixed-column-wrap :data="results">
        <template slot-scope="{}">
          <v-data-table
            :headers="headers"
            :items="results"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[10]"
            :total-items="pagination.totalItems"
            class="inline-edit"
            item-key="shipmentId"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td style="color: red" v-if="props.item.hasBookingSa">
                {{ props.item.containerNo }}
              </td>
              <td v-if="!props.item.hasBookingSa">
                {{ props.item.containerNo }}
              </td>
              <td>
                {{
                  props.item.productCode
                    ? props.item.productCode + ":" + props.item.productName
                    : ""
                }}
              </td>
              <td>{{ props.item.skuCode }}</td>
              <td>{{ props.item.needReplace ? "要" : "" }}</td>
              <td>
                {{ props.item.partnerCode + ":" + props.item.partnerName }}
              </td>
              <td>
                {{
                  props.item.loadingPortCode + ":" + props.item.loadingPortName
                }}
              </td>
              <td>
                {{
                  props.item.dischargePortCode +
                  ":" +
                  props.item.dischargePortName
                }}
              </td>
              <td>{{ props.item.blNo }}</td>
              <td>
                {{ props.item.forwarderCode }} - {{ props.item.forwarderName }}
              </td>
              <td>{{ props.item.doNo }}</td>
              <td>{{ props.item.etd }}</td>
              <td>{{ props.item.eta }}</td>
              <td>{{ props.item.freeDays }}</td>
              <td>{{ props.item.displayStatus }}</td>
              <td>
                {{
                  showReserveInfo(props.item)
                    ? props.item.forecastDeliveryDate
                    : ""
                }}
              </td>
              <td>
                {{
                  showReserveInfo(props.item)
                    ? (props.item.finallyWarehouseCode || "") +
                      ":" +
                      (props.item.finallyWarehouseName || "")
                    : ""
                }}
              </td>
              <td>{{ props.item.remark }}</td>
              <td>
                <v-btn style="max-height: 24px" @click="editRemark(props.item)"
                  >編集</v-btn
                >
              </td>
              <td>
                <v-btn
                  style="max-height: 24px"
                  :disabled="deliverySend(props.item)"
                  @click="toDetail(props.item.shipmentId)"
                  >明細</v-btn
                >
              </td>
            </template>
          </v-data-table>
        </template>
      </fixed-column-wrap>
    </v-card>
    <excluded-instruction-dialog
      @load="search()"
      ref="excludedInstructionDialog"
    ></excluded-instruction-dialog>
    <change-free-days-dialog
      @load="load"
      ref="changeFreeDays"
    ></change-free-days-dialog>
    <container-dialog
      :warehouseShow="true"
      ref="containerDialog"
    ></container-dialog>
    <logistics-sku-detail ref="logistics"></logistics-sku-detail>
    <edit-remark-dialog @load="load" ref="remark"></edit-remark-dialog>
  </v-container>
</template>

<script>
import ExcludedInstructionDialog from "./ExcludedInstructionDialog.vue";
import DateFormat from "dateformat";
import FixedColumnTable from "./FixedColumnTable";
import ChangeFreeDaysDialog from "./ChangeFreeDaysDialog";
import ContainerDialog from "../B1300/containerDialog";
import LogisticsSkuDetail from "../B0600/LogisticsSkuDetail";
import EditRemarkDialog from "./EditRemarkDialog.vue";

export default {
  components: {
    ExcludedInstructionDialog,
    ChangeFreeDaysDialog,
    ContainerDialog,
    LogisticsSkuDetail,
    EditRemarkDialog,
  },
  methods: {
    clearQuery() {
      this.$clearQuery();
      this.multiStatus = [];
    },
    editLogisticsSku() {
      this.$http
        .get(`delivery-orders/doId/${this.selected[0].shipmentId}`)
        .then((res) => {
          this.$refs.logistics.popup(res.data.packages);
        });
    },
    packagesDownload() {
      this.$refs.containerDialog
        .popup("納入日別倉庫別コンテナ明細")
        .then((p) => {
          this.$download("/warehouse-reserve-reports/packages", {
            forecastDeliveryDateFrom: p.from,
            forecastDeliveryDateTo: p.to,
            buIds: p.buId && p.buId.join(","),
            warehouseIds: p.warehouseId && p.warehouseId.join(","),
            containerTypeIds: p.containerTypeId && p.containerTypeId.join(","),
            businessUnitIds: p.businessUnitId && p.businessUnitId.join(","),
            productCodes: p.productCode && p.productCode.join(","),
            warehouseGroupIds: p.groupId,
          }).catch((err) => {
            console.log(err);
            if ("TimeOut" === err) {
              this.$message(
                "Err",
                "検索結果が多いので、出力できません。検索条件を調整する上で、再度検索してください。"
              );
            }
          });
        });
    },
    load(force, query) {
      var actualQuery = query || this.query;
      this.$storeParams();
      this.autoload = true;
      this.selected = [];
      this.$http
        .get("/reserved-shipment", {
          params: {
            status: this.multiStatus.join(","),
            ...actualQuery,
            ...this.$pageable(),
            sort: "blNo,containerNos",
          },
        })
        .then((res) => {
          this.pagination.page = res.data.number + 1;
          this.pagination.rowsPerPage = res.data.size;
          this.pagination.totalItems = res.data.totalElements;
          this.results = res.data.content;

          // Promise.all(
          //   this.results.map((r) => {
          //     return this.$http
          //       .get(`/free-days/bl/${r.shipmentId}`)
          //       .then((res) => {
          //         r.freeDays = res.data
          //       })
          //   })
          // ).then(() => {
          this.preDealData(force);
          this.$forceUpdate();
          // })
        })
        .catch(() => {
          this.preDealData(force);
          this.$forceUpdate();
        });
    },
    preDealData(force) {
      if (force) {
        this.selected = [...this.results];
        this.excludedInstruction();
      }
      if (this.preSelected.length > 0) {
        this.selected = this.preSelected.map((p) => ({
          ...p,
          shipmentId: p.id,
        }));
      }
    },
    showReserveInfo(item) {
      return !(
        item.displayStatus === "例外納入指示申請取消" ||
        item.displayStatus === "例外納入指示拒否" ||
        item.displayStatus === "事前例外納入指示申請取消" ||
        item.displayStatus === "事前例外納入指示拒否"
      );
    },
    deliverySend(shipment) {
      return (
        shipment.status !== "指示Mail送信済" &&
        shipment.status !== "SJL送信済" &&
        shipment.status !== "SA一時保存-SJL" &&
        shipment.status !== "事前納入指示Mail送信済"
      );
    },
    toDetail(id) {
      this.$http.get(`/delivery-orders/${id}/booking-count`).then((res) => {
        if (res.data > 0) {
          this.$confirm({
            content: "事前納入指示があります。置き換えますか。",
            rejectAction: "いいえ",
          })
            .then(() => {
              this.replace(id);
            })
            .catch(() => {
              this.$router.push({
                name: "B2300WarehouseDetail",
                query: {
                  id: id,
                },
              });
            });
        } else {
          this.$router.push({
            name: "B2300WarehouseDetail",
            query: {
              id: id,
            },
          });
        }
      });
    },
    openChangeFreeDaysDialog() {
      this.$refs.changeFreeDays.popup(this.selected);
    },
    updateSelected(selected) {
      this.selected = selected;
    },
    needNotReserve() {
      Promise.all(
        this.selected.map((s) => {
          return this.$http.put(
            `/warehouse-container-settings/change-need-reserve/${s.shipmentId}`
          );
        })
      )
        .then(() => {
          this.$message("", "納入指示画面へ遷移しました。");
          this.$router.push({
            name: "B0600",
            params: {
              blNo: this.selected[0].blNo,
              selected: this.selected,
            },
          });
        })
        .catch(() => {
          this.$message("", "納入指示画面へ遷移できません。");
        });
    },
    excludedInstruction() {
      this.$router.push({
        name: "B2300ExcludedInstruction",
        query: {
          ids: this.selected.map((s) => s.shipmentId).join(","),
          today: this.today,
        },
      });
      // this.$refs.excludedInstructionDialog.popup(this.selected[0], this.today)
    },
    randomInstruction() {
      this.$router.push({
        name: "B2300AutoSet",
        query: {
          type: "multiply",
          id: this.selected[0].shipmentId,
          shipments: this.selected,
        },
      });
    },
    adjustContainers() {
      this.$router.push("/B2300/adjust-containers");
    },
    toWarehouseSetting() {
      this.$router.push("/B2300/warehouse-setting");
    },

    search() {
      this.query.multiStatusString =
        this.multiStatus && this.multiStatus.join(",");
      this.$storeParams();
      this.pagination.page = 0;
      this.selected = [];
      this.preSelected = [];
      this.load();
    },
    initMultiStatus() {
      this.multiStatus =
        (this.query.multiStatusString &&
          this.query.multiStatusString.split(",")) ||
        [];
    },

    send() {
      if (
        this.selected.map((s) => s.finallyWarehouseId).filter((s) => s == null)
          .length > 0
      ) {
        this.$message(
          "Error",
          "最終納入場所が設定されていないので、送信できません。"
        );
        return false;
      }
      if (
        this.selected
          .map((s) => s.forecastDeliveryDate)
          .filter((s) => s == null).length > 0
      ) {
        this.$message("Error", "納入予定日は入力必須項目です");
        return false;
      }
      if (this.hasSent) {
        this.$message("Error", "既に送信済み");
        return false;
      } else {
        var errorMsg = [];
        var data = this.selected;
        var i = 0;
        this.dealInstructionSend(data, i, errorMsg);
      }
    },
    dealInstructionSend(data, i, errorMsg) {
      this.$http
        .put(`/delivery-orders/${data[i].shipmentId}/send-email-date`)
        .then(() => {
          this.doInstructionSend(i, data, errorMsg);
        })
        .catch(() => {
          errorMsg.push(data[i]);
          this.doInstructionSend(i, data, errorMsg);
        });
    },

    doInstructionSend(i, data, errorMsg) {
      if (i < data.length - 1) {
        this.dealInstructionSend(data, i + 1, errorMsg);
      } else {
        if (errorMsg.length === 0) {
          this.selected = [];
          this.load();
          this.$message("", "納入指示済");
        }
        if (errorMsg.length > 0) {
          console.log(errorMsg);
          var msg = errorMsg.map((e) => e.blNo + "-" + e.branchCode).join(",");
          this.selected = [];
          this.load();
          this.$message("", msg + ":" + "ERROR");
        }
      }
    },
    replace(id) {
      var id = id || this.selected[0].shipmentId;
      this.$http
        .get(`/delivery-orders/can-replace/${id}`)
        .then(() => {
          this.$router.push({
            path: "/replaced",
            query: {
              id: id,
            },
          });
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
    cancelBookingSa() {
      this.$confirm({
        content: "該当事前仮取消して宜しいでしょうか？",
      }).then(() => {
        this.$http
          .put(
            `/delivery-orders/booking-sa/cancel/${this.selected[0].shipmentId}`
          )
          .then(() => {
            this.$message("", "事前仮取消が完了しました。");
            this.load();
          })
          .catch(() => {
            this.$message("", "事前仮取消が失敗しました。");
          });
      });
    },
    editRemark(shipment) {
      this.$refs.remark.popup(shipment);
    },
  },
  data() {
    return {
      pagination: {
        page: 0,
      },
      results: [],
      loading: false,
      query: {},
      selected: [],
      multiStatus: [],
      dialog: {
        show: false,
      },
      headers: [
        {
          text: "コンテナ NO",
          value: "",
          sortable: false,
          class: "fixed",
        },
        {
          text: "品種名",
          value: "",
          sortable: false,
          class: "fixed",
        },
        {
          text: "代表品番",
          value: "",
          sortable: false,
          class: "fixed",
        },
        {
          text: "置換要否",
          value: "",
          sortable: false,
        },

        {
          text: "海外取引先",
          value: "",
          sortable: false,
        },
        {
          text: "積出港",
          value: "",
          sortable: false,
        },
        {
          text: "陸揚港",
          value: "",
          sortable: false,
        },
        {
          text: "B/L No",
          value: "",
          sortable: false,
        },
        {
          text: this.$t("app.labels.forwarder"),
          value: "",
          sortable: false,
        },
        {
          text: "D/O No",
          value: "",
          sortable: false,
        },
        {
          text: "ETD",
          value: "",
          sortable: false,
        },
        {
          text: "ETA",
          value: "",
          sortable: false,
        },
        {
          text: "フリー期限",
          value: "",
          sortable: false,
        },
        {
          text: "ステータス",
          value: "",
          sortable: false,
        },
        {
          text: "納入予定日",
          value: "",
          sortable: false,
        },
        {
          text: "最終納入場所",
          value: "",
          sortable: false,
        },
        {
          text: "コメント",
          value: "",
          sortable: false,
        },
        {
          text: "コメント編集",
          value: "",
          sortable: false,
        },
        {
          text: "ACTION",
          value: "",
          sortable: false,
        },
      ],
      status: [
        {
          key: 1,
          value: "指示Mail送信済",
          sortable: false,
        },
        {
          key: 12,
          value: "事前納入指示メール送信済",
          sortable: false,
        },
        {
          key: 2,
          value: "例外納入指示申請",
          sortable: false,
        },
        {
          key: 3,
          value: "例外納入指示申請取消",
          sortable: false,
        },
        {
          key: 4,
          value: "例外納入指示拒否",
          sortable: false,
        },
        {
          key: 5,
          value: "納入指示未送信",
          sortable: false,
        },
        {
          key: 6,
          value: "納入指示済",
          sortable: false,
        },
        {
          key: 7,
          value: "受入確認済",
          sortable: false,
        },
      ],
      errors: {
        WAREHOUSE_OR_DATE_DIFFERENT:
          "納入場所または納入予定日が違うため、事前仮合併ができません。",
        UP_TO_LIMIT: "受入上限本数を超えてしまうので、送信できません。",
        CAN_NOT_REPLACE: "置換えできません。",
        DIFFERENT_BUSINESS_UNIT: "BUが一致しないので、予約できません。",
      },
      preSelected: [],
    };
  },
  mounted() {
    this.$loadParams();
    this.initMultiStatus();
    var blNo = this.$route.query.blNo;
    var containerNo = this.$route.query.containerNo;
    if (blNo && containerNo) {
      this.query.blNo = blNo;
      this.query.containerNo = containerNo;
      this.load(true, this.query);
    } else {
      if (blNo) {
        this.query.blNo = blNo;
      }
      var params = this.$route.params;
      if (params.blNo) {
        this.query.blNo = params.blNo;
        this.preSelected = params.selected;
        this.load();
      }
    }
  },
  watch: {
    pagination() {
      if (this.autoload) this.load();
    },
  },
  computed: {
    canEditLogisticsSku() {
      return (
        this.selected.length === 1 &&
        this.selected.filter((s) => s.buCode !== "ME").length === 0
      );
    },
    canDeliverySend() {
      return (
        this.selected.filter(
          (s) =>
            s.displayStatus === "例外納入指示申請" ||
            s.displayStatus === "例外納入指示拒否" ||
            s.displayStatus === "例外納入指示申請取消" ||
            s.displayStatus === "事前例外納入指示申請" ||
            s.displayStatus === "事前例外納入指示拒否" ||
            s.displayStatus === "事前例外納入指示申請取消"
        ).length === 0
      );
    },
    canCancelBookingDo() {
      return (
        this.selected.length === 1 &&
        this.selected.filter((s) => s.hasBookingSa).length === 1 &&
        this.selected.filter((s) => s.displayStatus === "事前受入確認済")
          .length === 0
      );
    },
    today() {
      return DateFormat(new Date(), "yyyy-mm-dd");
    },
    canMove() {
      return (
        this.selected.filter(
          (s) =>
            s.displayStatus !== "指示Mail送信済" &&
            s.displayStatus !== "事前納入指示Mail送信済"
        ).length === 0
      );
    },
    canDoExceptionApply() {
      return (
        this.selected.filter(
          (s) =>
            s.status !== "指示Mail送信済" &&
            s.status !== "事前納入指示Mail送信済"
        ).length === 0
      );
    },
    canChangeFreeDays() {
      return (
        this.sameBL &&
        this.selected.filter(
          (s) =>
            s.status !== "指示Mail送信済" &&
            s.status !== "事前納入指示Mail送信済" &&
            s.status !== "納入指示済" &&
            s.status !== "事前納入指示済"
        ).length === 0
      );
    },
    sameBL() {
      var r = this.selected
        .map((s) => s.blNo)
        .reduce((t, s) => {
          if (t.indexOf(s) == -1) {
            t.push(s);
          }
          return t;
        }, []);
      return r.length === 1;
    },
    hasSent() {
      return (
        this.selected
          .map((s) => s.status)
          .filter(
            (s) =>
              s !== "指示Mail送信済" &&
              s !== "SJL送信済" &&
              s !== "SA一時保存-SJL" &&
              s !== "事前納入指示Mail送信済"
          ).length > 0
      );
    },
  },
};
</script>

<style scoped>
/deep/ .v-btn {
  margin: 0px 20px 20px 0px !important;
}
</style>
